<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import CalidErrorPage from '@/components/Calid/CalidErrorPage.vue';

const router = useRouter();

const variants = [
  {
    theme: 'ice',
    title: 'Page Not Found',
    headline: 'The trail has gone properly cold.',
    message: 'Our servers are frostier than a January dawn in Edinburgh. Give us a tick while we warm the route back up.',
  },
  {
    theme: 'fire',
    title: 'Page Not Found',
    headline: 'The trail has gone up in flames.',
    message: 'Our servers must be hotter than a midsummer day in the Sahara. Give us a moment to cool things down and get you back on track.',
  },
];

const variant = ref(variants[Math.floor(Math.random() * variants.length)]);

const actions = [
  {
    label: 'Return to dashboard',
    icon: 'pi pi-home',
    variant: 'primary',
    onClick: () => router.push('/dashboard'),
  },
  {
    label: 'Go back',
    icon: 'pi pi-arrow-left',
    variant: 'ghost',
    onClick: () => router.back(),
  },
];
</script>

<template>
  <CalidErrorPage
    status="404"
    :title="variant.title"
    :headline="variant.headline"
    :message="variant.message"
    :theme="variant.theme"
    hint="Lost in the ether, but still under Calid's watchful eye."
    :actions="actions"
  />
</template>

